import "./../styles/notFound.css";

export default function NotFound({currentPage}) {
  const goHome = () => {
    window.location.href = currentPage;
  };

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="page-wrapper">
      <div className="card-404">
        <h1 className="brand">FlowWise</h1>
        <p className="subtitle">Page not found</p>

        <div className="error-code">404</div>

        <h2 className="title">
          Oops! The page you're looking for doesn't exist.
        </h2>

        <p className="description">
          It looks like the link is broken or the page has been moved.
          <br />
          Don't worry, it happens to the best of us.
        </p>

        <button className="primary-btn" onClick={goHome}>
          Go to Homepage
        </button>

        <button className="link-btn" onClick={goBack}>
          ← Back to previous page
        </button>
      </div>
    </div>
  );
}
